import { render } from "./EmptySection.vue?vue&type=template&id=307f0de7"
import script from "./EmptySection.vue?vue&type=script&lang=js"
export * from "./EmptySection.vue?vue&type=script&lang=js"

import exportComponent from "/Users/albert/Develop/Dashboard/dashboard-frontend-private/node_modules/vue-loader-v16/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])